var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WishList50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M40 45L8 45 8 3 30 3 40 13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1f5fe",
    d: "M38.5 14L29 14 29 4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M18 23H34V25H18zM18 19H34V21H18zM14 19H16V21H14zM14 23H16V25H14zM14 35H16V37H14zM14 27H16V29H14zM14 31H16V33H14zM34 27v1.26C33.35 28.09 32.68 28 32 28c-1.4 0-2.71.36-3.86 1H18v-2H34zM24.08 37H18v-2h6.06C24.02 35.33 24 35.66 24 36 24 36.34 24.02 36.67 24.08 37zM25.77 31c-.49.6-.89 1.27-1.18 2H18v-2H25.77z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M42,30c-2.1,0-3.9,1.1-5,2.7c-1.1-1.6-2.9-2.7-5-2.7c-3.3,0-6,2.7-6,6c0,6,11,12,11,12s11-6,11-12 C48,32.7,45.3,30,42,30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WishList50);
export default __webpack_public_path__ + "static/media/icons8-wish-list-50.bb2d6d1cb75172c67e76edec5b4ce833.svg";
export { ForwardRef as ReactComponent };